import type { Locale } from '@/types/resume.types'

/**
 * UI-микрокопия для vue-i18n.
 *
 * Сюда вынесены строки интерфейса, которых нет в контент-данных резюме
 * (заголовки секций, бейджи, подписи панели Tweaks). Структурированный контент
 * (опыт, проекты, навыки и т.д.) живёт в `data/resume.ts` и читается через `useResume`.
 */
export interface MessageSchema {
  sections: {
    experienceTitle: string
    skillsTitle: string
    projectsTitle: string
    backgroundEyebrow: string
    eduLangTitle: string
    contactEyebrow: string
  }
  experience: {
    current: string
  }
  edu: {
    grade: string
  }
  tweaks: {
    title: string
    customize: string
    appearance: string
    accent: string
    glow: string
    anim: string
  }
}

export const messages: Record<Locale, MessageSchema> = {
  en: {
    sections: {
      experienceTitle: 'Professional journey',
      skillsTitle: 'Technical toolkit',
      projectsTitle: 'Selected work',
      backgroundEyebrow: 'Background',
      eduLangTitle: 'Education & languages',
      contactEyebrow: 'Contact',
    },
    experience: { current: 'Current' },
    edu: { grade: 'Grade' },
    tweaks: {
      title: 'Tweaks',
      customize: 'Customize',
      appearance: 'Appearance',
      accent: 'Accent color',
      glow: 'Background glow',
      anim: 'Animations',
    },
  },
  ru: {
    sections: {
      experienceTitle: 'Профессиональный путь',
      skillsTitle: 'Технический стек',
      projectsTitle: 'Избранные проекты',
      backgroundEyebrow: 'Бэкграунд',
      eduLangTitle: 'Образование и языки',
      contactEyebrow: 'Контакты',
    },
    experience: { current: 'Сейчас' },
    edu: { grade: 'Балл' },
    tweaks: {
      title: 'Tweaks',
      customize: 'Настроить',
      appearance: 'Оформление',
      accent: 'Акцентный цвет',
      glow: 'Подсветка фона',
      anim: 'Анимации',
    },
  },
  uz: {
    sections: {
      experienceTitle: 'Kasbiy yo‘lim',
      skillsTitle: 'Texnik stek',
      projectsTitle: 'Tanlangan loyihalar',
      backgroundEyebrow: 'Tajriba',
      eduLangTitle: 'Ta’lim va tillar',
      contactEyebrow: 'Aloqa',
    },
    experience: { current: 'Hozir' },
    edu: { grade: 'Baho' },
    tweaks: {
      title: 'Tweaks',
      customize: 'Sozlash',
      appearance: 'Ko‘rinish',
      accent: 'Urg‘u rangi',
      glow: 'Fon yorug‘ligi',
      anim: 'Animatsiyalar',
    },
  },
}
